import { newsActions } from '../actions'

const {
  FETCHING_NEWS,
  FETCH_NEWS,
  FETCH_NEWS_ERROR,
} = newsActions

const initialState = {
  fetching: {
    news: false,
  },
  news: {},
  fetch_errors: {
    news: false,
  }
}

const news = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_NEWS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          news: action.value
        }
      }

    case FETCH_NEWS:
      return {
        ...state,
        items: action.data,
        fetching: {
          ...state.fetching,
          news: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          news: false
        }
      }

    case FETCH_NEWS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          news: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          news: true
        }
      }

    default:
      return state
  }
}

export default news



// WEBPACK FOOTER //
// ./src/reducers/news.js